import React from "react";
import { TreeNode as OrgTreeNode } from "react-organizational-chart";
import { HierarchyUser } from "../../../utils/api/hierarchyAPI";
import EmployeeCard from "./EmployeeCard";

interface TreeNodeProps {
  user: HierarchyUser;
  onAssignManager?: (user: HierarchyUser) => void;
  onUserClick?: (user: HierarchyUser) => void;
  onDragStart?: (user: HierarchyUser) => void;
  onDragEnd?: () => void;
  onDrop?: (targetUser: HierarchyUser, draggedUser: HierarchyUser) => void;
}

const TreeNode: React.FC<TreeNodeProps> = ({
  user,
  onAssignManager,
  onUserClick,
  onDragStart,
  onDragEnd,
  onDrop,
}) => {
  return (
    <OrgTreeNode
      label={
        <EmployeeCard
          user={user}
          onAssignManager={onAssignManager}
          onClick={onUserClick}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDrop={onDrop}
        />
      }
    >
      {user.children &&
        user.children.map((child) => (
          <TreeNode
            key={child._id}
            user={child}
            onAssignManager={onAssignManager}
            onUserClick={onUserClick}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onDrop={onDrop}
          />
        ))}
    </OrgTreeNode>
  );
};

export default TreeNode;
